export class numberHelper {
  static formatMoney(value: number): string {
    if (Number.isNaN(value)) {
      return '';
    }
    let formattedString: string = value.toFixed(2); // Format with two decimal places
    return `$${formattedString}`;
  }
}

export const isFullDiscount = (price: number, discount: number) => {
  return price === discount;
};
